var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTdesignTaskAddFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2592_11374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 1H8V5H16V1Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 3H3V23H13.876C13.0193 21.9035 12.537 20.5611 12.5002 19.17C12.4633 17.779 12.8739 16.4129 13.6714 15.2726C14.4689 14.1324 15.6113 13.2781 16.9305 12.8355C18.2497 12.3929 19.6762 12.3854 21 12.814V3H18V7H6V3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 20H20V24H18V20H14V18H18V14H20V18H24V20Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2592_11374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTdesignTaskAddFilled);
export default __webpack_public_path__ + "static/media/tdesign_task-add-filled.9f41011007d6211252ec0105d5c90a3f.svg";
export { ForwardRef as ReactComponent };